import { Icons } from 'utils/icons'

import * as S from './FeatureTopic.styles'
import { FeatureTopic } from './FeatureTopic'

const handMoneyIcon = (
  <Icons.HandMoney data-testid="hand-money-icon" color="var(--gray500)" width={24} height={24} />
)
const coinIcon = (
  <Icons.Coin data-testid="coin-icon" color="var(--gray500)" width={24} height={24} />
)
const loopIcon = (
  <Icons.Loop data-testid="loop-icon" color="var(--gray500)" width={24} height={24} />
)

export const features = [
  {
    id: 1,
    icon: coinIcon,
    description: 'Sorteios mensais de R$ 7.000,00 + 4 sorteios extras ao longo do ano.',
  },
  {
    id: 2,
    icon: handMoneyIcon,
    description: 'Chance de ganhar até R$ 100,00 na hora.',
  },
  {
    id: 3,
    icon: loopIcon,
    description: 'Pague com seus pontos Loop.',
  },
]

export const FeatureTopicList = () => (
  <S.FeatureTopicList data-testid="feature-topic-list">
    {features.map((feature) => (
      <FeatureTopic key={feature.id} icon={feature.icon} description={feature.description} />
    ))}
  </S.FeatureTopicList>
)
